import React from "react";
import formItemLayout from "../../../common/form/formItemLayout";
import {
    disabledStartDate,
    getLanguage,
    numberFormatPlaces,
    numFormatterMinus, startDateChange,
    validateMessages
} from "../../../source/js/common";
import {colLayout, formItemTailLayout, formLayout} from "../../../constant/css";
import { IDType, IndividualIdType} from "../../../dictionary";
import NonIndividualBuyerInfo from "../../component/buyer/nonIndividualBuyerInfo";
import AisinoRow from "../../../baseComponent/rowAndCol/AisinoRow";
import AisinoCol from "../../../baseComponent/rowAndCol/AisinoCol";
import AisinoForm from "../../../baseComponent/form/AisinoForm";
import FormItemInput from "../../../common/form/input/FormItemInput";
import AisinoFormItem from "../../../baseComponent/form/AisinoFormItem";
import CheckSquareOutlined from "@ant-design/icons/es/icons/CheckSquareOutlined";
import {isEmpty} from "../../../common/utils/StringUtils";
import {postSync} from "../../../common/utils/http";
import {aisinoInfoModal, aisinoInfoModalForEx} from "../../../common/modal/AisinoModalMethod";
import BigNumber from "bignumber.js";
import {Carousel, ConfigProvider, Empty, Table} from "antd";
import {CaretLeftOutlined, CaretRightOutlined} from "@ant-design/icons";
import {AisinoButton} from "../../../baseComponent/button";
import QrScanner from "./qrScanner";
import $ from 'jquery';
import {numStrFormat} from "../../../common/utils/NumberUtils";
import FormItemDatePicker from "../../../common/form/datePicker/FormItemDatePicker";
import {
    invoiceDate,
} from "../../../constant/js/formItemNameLabel/en_US/invoice";
import moment from "moment";

const invoiceLan = require('../../../constant/js/formItemNameLabel/'+getLanguage()+'/invoice.js');
const commonLan = require('../../../constant/js/formItemNameLabel/'+getLanguage()+'/common.js');
const exciseButtonStyle = { position: "absolute", top: "0px", width: "100%", textAlign: "right",pointerEvents: "none"};

//formItem样式
export const formItemCaptchaLayout = {
    wrapperCol: {
        xs: 10,
        sm: {span:10,offset: 2},
        md: {span:10,offset: 2},
        lg: {span:10,offset: 2}
    }
};

const itemColumns=[
    {title: commonLan.noIndex.label,dataIndex:'_index',width: 40, render:(text,record,index)=>{
            return <span>{index+1}</span>
        }},
    {title: invoiceLan.itemName.label,dataIndex:'itemDesc',width: 180,},
    {title: invoiceLan.quantity.label,dataIndex:'quantity',width: 100,render:(text,record)=>{
            return numberFormatPlaces(text,2);
        }},
    {title: invoiceLan.subtotal.label,dataIndex:'subtotal',width: 100,render:(text,record)=>{
            return numberFormatPlaces(text,2);
        }},
]
class InvoiceIssuanceBill extends React.Component {

    constructor(props){
        super(props);
        this.state={
            disable:false,
            captchaId:"",
            supplierTin:"",
            netAmount:"",
            dotPosition: 'top',
            dataSource:[],
            page1:true,
            page2:false,
            page3:false,
            showScanner:false,
            invoiceNumberLabel:invoiceLan.billNo.label,
            displayDecimalSetting:2,
            storeBillDateFlag:false,
        }
        const searchParams = new URLSearchParams(props.location.search);
        let supplierTin = searchParams.get('supplierTin');
        if(supplierTin){
            this.state.supplierTin=supplierTin;
        }else{
            aisinoInfoModal(invoiceLan.requestAddressIncorrect,function () {
                window.location.href = 'about:blank';
            })
        }
        let typeCode = searchParams.get('typeCode');
        if(!isEmpty(typeCode)){
            if(typeCode === 'invoice'){
                this.state.invoiceNumberLabel = invoiceLan.h5InvoiceCodeNumber2.label;
            }
            else if(typeCode === 'storeBillDate'){
                this.state.storeBillDateFlag = true;
            }
        }
        this.invoiceForm=React.createRef();
        this.itemTable=React.createRef();
        this.buyerInfo=React.createRef();
        this.qrScannerRef=React.createRef();
        this.buyerInfoShowAddress=React.createRef();
    }
    componentDidMount() {
        const that = this;
        this.refreshCaptcha();
        let displayDecimalSetting = sessionStorage.getItem("displayDecimalSetting");
        if(!isEmpty(displayDecimalSetting)){
            this.state.displayDecimalSetting = parseInt(displayDecimalSetting);
        }
        setInterval(function(){
            that.refreshCaptcha();
        }, 170000);
    }

    refreshCaptcha(){
        this.invoiceForm.current.setFieldsValue({captcha:''});
        let captcha_id = Math.random().toString(36).slice(-10);
        while (!captcha_id) {
            captcha_id = Math.random().toString(36).slice(-10);
        }
        this.state.captchaId=captcha_id;
        this.setState({})
    }

    submitBtnClick(){
        const that = this;
        const invoiceForm = that.invoiceForm.current;
        const itemTable = that.itemTable.current;
        const totalNetAmount = that.state.netAmount;
        let itemTableData = that.state.dataSource;
        if(itemTableData){
            const maxValue=new BigNumber("9999999999999999");
            //2024-11-26 提交时，若Total Net Amount为空，则取 SUM (商品行 Total Excluding Tax) ，如果求和后的整数部分大于16位，则加校验，给提示
            if(isEmpty(totalNetAmount)){
                let totalNetSum = new BigNumber(0);
                for (let i = 0; i < itemTableData.length; i++) {
                    let totalExcludingTax=itemTableData[i].totalExcludingTax;
                    totalNetSum = totalNetSum.plus(totalExcludingTax);
                }
                if(totalNetSum.comparedTo(maxValue) > 0){
                    aisinoInfoModal(invoiceLan.totalNetAmountOutOfLimit);
                    return ;
                }
            }
        }

        invoiceForm.validateFields().then(values => {
            if(values.buyerIdType===IndividualIdType.MYPR||values.buyerIdType===IndividualIdType.MYKAS){
                // 0726要求修改为 passport
                values.buyerIdType=IDType.PASSPORT
            }
            values.captcha_id = this.state.captchaId;
            values.belongTin = this.state.supplierTin;
            if(this.state.storeBillDateFlag){
                values.documentNum =this.changeDateFormat(values.invoiceDate) + "-" +values.storeCode.trim() + "-" +values.billNo.trim();
            }
            else{
                values.documentNum = values.storeCode.trim() + "-" +values.billNo.trim();
            }
            postSync("aisino/transactionDataManagement/issueInvoice",values,true,function(data){
                that.refreshCaptcha.call(that);
            }).then(res=>{
                if(res){
                    if(res.resCode==='success'){
                        //开票成功
                        aisinoInfoModal(invoiceLan.submitSuccessCheckEmail,function(){
                            invoiceForm.resetFields();
                            // itemTable.setData([]);
                            that.state.dataSource=[];
                            that.state.page1=true;
                            that.state.page2=false;
                            that.state.page3=false;
                            that.refreshCaptcha();
                        })
                    }else{
                        aisinoInfoModal(res.resMsg,function(){
                            that.refreshCaptcha();
                        })
                    }
                }
            })
        })
    }
    clearDocumentNum(){
        const that = this;
        that.invoiceForm.current.resetFields();
        // that.itemTable.current.setData([]);
        that.setState({dataSource:[]});
    }
    changeDateFormat(timeStamp){
        let date = new Date(timeStamp);
        let year = date.getFullYear(); // 年份
        let month = ('0' + (date.getMonth() + 1)).slice(-2); // 月份，月份是从0开始的，所以要+1，并且需要补0
        let day = ('0' + date.getDate()).slice(-2); // 日期，补0
        let formattedDate = day + month + year;
        return formattedDate;
    }
    checkOutData(){
        const that = this;
        const form = that.invoiceForm.current;
        const itemTable = that.itemTable.current;
        let storeCode = !isEmpty(form.getFieldValue("storeCode")) ?form.getFieldValue("storeCode").trim():"";
        let billNo = !isEmpty(form.getFieldValue("billNo"))?form.getFieldValue("billNo").trim():"";
        let total = form.getFieldValue("total");
        const supplierTin = that.state.supplierTin;
        if(!isEmpty(storeCode) && !isEmpty(billNo) &&!isEmpty(total)){
            let documentNum = storeCode+"-"+billNo;
            if(this.state.storeBillDateFlag){
                let invoiceDate =form.getFieldValue("invoiceDate");
                if(isEmpty(invoiceDate)){
                    return;
                }
                documentNum = this.changeDateFormat(invoiceDate)+"-"+storeCode+"-"+billNo;
            }
            if(documentNum.length > 50){
                if(this.state.storeBillDateFlag){
                    aisinoInfoModal(invoiceLan.storeCodeBillExceed,function (){
                        that.clearDocumentNum.call(that);
                    });

                }else{
                    aisinoInfoModal(invoiceLan.storeCodeBillExceed2,function (){
                        that.clearDocumentNum.call(that);
                    });
                }
                return;
            }
            // 2025-07-03变更 允许输入4位，但是仍然使用两位精度做判断
            total=numStrFormat(total).replace(/,/g,"");
            postSync("aisino/transactionDataManagement/getInvoiceDetails",{documentNum:documentNum,total:total,supplierTin:supplierTin},null,function(data){
                that.clearDocumentNum.call(that);
            }).then(res=>{
                if(res){
                    if(typeof res === 'string'){
                        aisinoInfoModalForEx(<div style={{maxHeight:"300px",overflowY: "auto"}}>{invoiceLan.transactionInfoIncomplete
                                + JSON.stringify(JSON.parse(res), null, 4)}</div>
                            ,function(){
                                that.clearDocumentNum();
                            })
                        return;
                    }
                    form.setFieldsValue({
                        id:res.id,
                        transactionDate:res.transactionDate
                    });
                    if(res.buyerInfo){
                        this.setBuyerInfo(res.buyerInfo);
                    }
                    this.state.netAmount=res.netAmount;
                    this.setState({})
                    // itemTable.loadTableData({documentNum:documentNum,supplierTin:supplierTin});
                    postSync("aisino/transactionDataManagement/getOrdersDetails", {documentNum:documentNum,supplierTin:supplierTin},true).then(response => {
                        this.state.dataSource = response.records;
                        this.setState({})
                    });
                }
            })
        }
    }
    setBuyerInfo(buyerInfo){
        const that = this;
        let taxpayerLocal ={};
        taxpayerLocal.buyerIdType = buyerInfo.buyerIdType;
        taxpayerLocal.buyerIdValue = buyerInfo.buyerIdValue;
        taxpayerLocal.buyerTin = buyerInfo.buyerTin;
        taxpayerLocal.buyerName = buyerInfo.buyerName;
        taxpayerLocal.buyerSst = buyerInfo.buyerSst;
        taxpayerLocal.buyerContactNum = buyerInfo.buyerContactNum;
        taxpayerLocal.buyerEmail = buyerInfo.buyerEmail;
        taxpayerLocal.buyerCode = buyerInfo.buyerCode;
        taxpayerLocal.buyerCountryCode = buyerInfo.buyerCountryCode;
        taxpayerLocal.buyerStateCode = buyerInfo.buyerStateCode;
        taxpayerLocal.buyerCityName = buyerInfo.buyerCityName;
        taxpayerLocal.buyerAddressLine0 = buyerInfo.buyerAddressLine0;
        taxpayerLocal.buyerAddressLine1 = buyerInfo.buyerAddressLine1;
        taxpayerLocal.buyerAddressLine2 = buyerInfo.buyerAddressLine2;
        taxpayerLocal.buyerPostalZone = buyerInfo.buyerPostalZone;
        that.invoiceForm.current.setFieldsValue(taxpayerLocal);
        that.buyerInfoShowAddress.current.countryCodeChange();
    }
    totalChange(e){
        const invoiceForm=this.invoiceForm.current;
        let val = numFormatterMinus(e.target.value,12,this.state.displayDecimalSetting);
        invoiceForm.setFieldsValue({
            total:val
        })
    }
    changeIdType(val){
        const invoiceForm=this.invoiceForm.current;
        if(val!==IndividualIdType.BRN){
            const idTypeData =this.buyerInfo.current.getIndividualIdTypeData();
            idTypeData.map(item=>{
                if(item.value===val){
                    invoiceForm.setFieldsValue({buyerTin:item.description});
                }
            })
        }else{
            invoiceForm.setFieldsValue({buyerTin:null});
        }
        invoiceForm.setFieldsValue({buyerIdValue:""});
        this.buyerInfo.current.setDbBuyerTin("");
    }
    nextClick(curTab){
        const that = this;
        const invoiceForm = that.invoiceForm.current;
        if(curTab == 1){
            if(this.state.storeBillDateFlag){
                invoiceForm.validateFields(["storeCode","billNo","total","invoiceDate"]).then(trueInfo =>{
                    this.state.page1=false;
                    this.state.page2=true;
                    this.setState({});
                });
            }
            else{
                invoiceForm.validateFields(["storeCode","billNo","total"]).then(trueInfo =>{
                    this.state.page1=false;
                    this.state.page2=true;
                    this.setState({});
                });

            }
        }
        else if(curTab == 2){
            invoiceForm.validateFields(["buyerIdType","buyerIdValue","buyerTin","buyerName","buyerContactNum","buyerEmail"]).then(trueInfo =>{
                this.state.page2=false;
                this.state.page3=true;
                this.setState({});
            });
        }

    }
    preClick(curTab){
        if(curTab==0){
            this.state.page1=true;
            this.state.page2=false;
            this.setState({});
        }
        if(curTab==1){
            this.state.page2=true;
            this.state.page3=false;
            this.setState({});
        }
    }

    showScannerFun(){
        //打开扫描时 调整样式 ant-layout  ant-row
        $('#app .ant-layout').css("padding-bottom",'0');
        $('#app .ant-row').css("display",'none');
        this.qrScannerRef.current.startScanner();
        this.setState({
            showScanner:true
        })
    }
    scanResult(data){
        const that = this;
        postSync("aisino/transactionDataManagement/getTaxpayerInfoByQrCode", {qrCode:data},true).then(response => {
            if(response){
                const taxpayerInfo = JSON.parse(response);
                let taxpayerLocal ={};
                taxpayerLocal.buyerIdType = taxpayerInfo.idType;
                taxpayerLocal.buyerIdValue = taxpayerInfo.idNumber;
                taxpayerLocal.buyerTin = taxpayerInfo.tin;
                taxpayerLocal.buyerName = taxpayerInfo.name;
                taxpayerLocal.buyerSst = taxpayerInfo.sst;
                taxpayerLocal.buyerContactNum = taxpayerInfo.contactNumber;
                taxpayerLocal.buyerEmail = taxpayerInfo.email;
                taxpayerLocal.buyerCode = taxpayerInfo.name;
                taxpayerLocal.buyerCountryCode = taxpayerInfo.country;
                taxpayerLocal.buyerStateCode = taxpayerInfo.state;
                taxpayerLocal.buyerCityName = taxpayerInfo.city;
                taxpayerLocal.buyerAddressLine0 = taxpayerInfo.addressLine0;
                taxpayerLocal.buyerAddressLine1 = taxpayerInfo.addressLine1;
                taxpayerLocal.buyerAddressLine2 = taxpayerInfo.addressLine2;
                taxpayerLocal.buyerPostalZone = taxpayerInfo.postalZone;
                that.invoiceForm.current.setFieldsValue(taxpayerLocal);
                that.buyerInfo.current.setDbBuyerTin(taxpayerInfo.tin);
            }
            //关闭扫描时 调整样式
            $('#app .ant-layout').css("padding-bottom",'10px');
            $('#app .ant-row').css("display",'');
            that.setState({
                showScanner:false
            })
            that.buyerInfoShowAddress.current.countryCodeChange();
        });
    }
    scanCancel(){
        $('#app .ant-layout').css("padding-bottom",'10px');
        $('#app .ant-row').css("display",'');
        this.setState({
            showScanner:false
        })
    }
    render() {
        const {disable,captchaId,page1,page2,page3,showScanner,invoiceNumberLabel,storeBillDateFlag }=this.state;
        // 定义 disabledDate 函数
        const disabledDate = (current) => {
            // 获取今天的日期
            const today = moment();
            // 如果当前日期大于今天，则返回 true，禁用该日期
            return current && current > today;
        };
        return(
            <div>
                <div style={{display:showScanner?'':'none'}}>
                    <QrScanner ref={this.qrScannerRef} resHandle={(data)=>this.scanResult(data)} scanCancel={()=>this.scanCancel()}/>
                </div>
                <div style={{display:!showScanner?'':'none'}}>
                    <div style={{textAlign: "center",fontSize:"26px",fontWeight:"bold",paddingTop:"10px"}}>
                        <p>{invoiceLan.invoiceIssuance}</p>
                    </div>
                    <div>
                        <AisinoForm {...formLayout} ref={this.invoiceForm} validateMessages={validateMessages()}>
                            <FormItemInput name={"id"} hidden={true}/>
                            <div style={{display:page1?"":"none"}}>
                                <div className={"qrCarouselDiv"}>
                                    {
                                        storeBillDateFlag ?
                                            formItemLayout([
                                                <FormItemInput  label={invoiceLan.onlyStoreCode.label} name={"storeCode"} rules={[{required: true},{max:50}]} onBlur={()=>this.checkOutData()}/>,
                                                <FormItemInput  label={invoiceNumberLabel} name={"billNo"} rules={[{required: true},{max:50}]} onBlur={()=>this.checkOutData()}/>,
                                                <FormItemInput  label={invoiceLan.totalAmount.label} name={"total"}  rules={[{required: true}]} onChange={(e)=>this.totalChange(e)} onBlur={()=>this.checkOutData()}/>,
                                                <FormItemDatePicker name={"invoiceDate"} label={invoiceLan.invoiceDate.label} rules={[{required: true}]} onChange={(e)=>this.checkOutData(e)}
                                                                    disabledDate={disabledDate} format={sessionStorage.getItem("dateFormatter")}/>
                                            ])
                                            :

                                            formItemLayout([
                                                <FormItemInput  label={invoiceLan.onlyStoreCode.label} name={"storeCode"} rules={[{required: true},{max:50}]} onBlur={()=>this.checkOutData()}/>,
                                                <FormItemInput  label={invoiceNumberLabel} name={"billNo"} rules={[{required: true},{max:50}]} onBlur={()=>this.checkOutData()}/>,
                                                <FormItemInput  label={invoiceLan.totalAmount.label} name={"total"}  rules={[{required: true}]} onChange={(e)=>this.totalChange(e)} onBlur={()=>this.checkOutData()}/>,
                                                <FormItemInput  label={invoiceLan.invoiceDateTime.label} name={"transactionDate"}  disabled={true} />,
                                            ])
                                    }
                                    <ConfigProvider
                                        renderEmpty={() => (
                                            <Empty
                                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                                                description={commonLan.noData}
                                            />
                                        )}
                                    >
                                    <Table
                                        ref={this.itemTable}
                                        size={"middle"}
                                        scroll={{y:200,x:0}}
                                        tableLayout={'fixed'}
                                        dataSource={this.state.dataSource}
                                        columns={itemColumns}
                                        loadUrl={'aisino/transactionDataManagement/getOrdersDetails'}
                                        rowSelection={false}
                                        pagination={false}
                                        rowClassName={(record, index) => {
                                            let className = 'light-row';
                                            if (index % 2 === 1) className = 'dark-row';
                                            return className;
                                        }}
                                    />
                                    </ConfigProvider>
                                </div>
                                <div className={"qrCarouselBtnDiv"}>
                                    <AisinoButton type="button" onClick={()=>this.nextClick(1)} icon={<CaretRightOutlined />} >
                                        {commonLan.nextButton.label}
                                    </AisinoButton>
                                </div>

                            </div>
                            <div style={{display:page2?"":"none"}}>
                                <div className={"qrCarouselDiv"}>
                                    <NonIndividualBuyerInfo ref={this.buyerInfo} disable={disable} h5Flag showH5Flag={true} showAddressFlag={false} changeIdType={(e)=>this.changeIdType(e)} fartherForm={this.invoiceForm} showScanner={()=>this.showScannerFun()}/>
                                </div>
                                <div className={"qrCarouselBtnDiv"}>
                                    <AisinoButton style={{marginRight:"20px"}} type="button" onClick={()=>this.preClick(0)} icon={<CaretLeftOutlined />} >
                                        {commonLan.previousButton.label}
                                    </AisinoButton>
                                    <AisinoButton type="button" onClick={()=>this.nextClick(2)} icon={<CaretRightOutlined />} >
                                        {commonLan.nextButton.label}
                                    </AisinoButton>
                                </div>
                            </div>
                            <div  style={{display:page3?"":"none"}}>
                                <div className={"qrCarouselDiv"}>
                                    <NonIndividualBuyerInfo ref={this.buyerInfoShowAddress} disable={disable} h5Flag  showH5Flag={false} showAddressFlag={true} fartherForm={this.invoiceForm}/>
                                    <AisinoRow style={{marginLeft: "-12px",marginRight: "-12px"}}>
                                        <AisinoCol {...colLayout} >
                                            <FormItemInput  label={invoiceLan.captcha.label} name="captcha" rules={[{required: true},{max:4}]}/>
                                            <AisinoFormItem {...formItemTailLayout} label={" "} style={exciseButtonStyle} >
                                                {captchaId?<img style={{height:"33px",marginLeft:"27px",pointerEvents: "auto"}} src={window.g.baseURL+"/invoice/aos/mainui/login/captcha?captcha_id="+captchaId+"&timestamp="+Date.parse(new Date())} onClick={() => this.refreshCaptcha()}/>:''}
                                            </AisinoFormItem>
                                        </AisinoCol>
                                    </AisinoRow>
                                </div>
                                <div className={"qrCarouselBtnDiv"}>
                                    <AisinoButton style={{marginRight:"20px"}} type="button" onClick={()=>this.preClick(1)} icon={<CaretLeftOutlined />} >
                                        {commonLan.previousButton.label}
                                    </AisinoButton>
                                    <AisinoButton type="button" htmlType="submit" icon={<CheckSquareOutlined/>}  onClick={()=>this.submitBtnClick()}>
                                        {commonLan.submitButton.label}
                                    </AisinoButton>
                                </div>
                            </div>
                        </AisinoForm>
                    </div>
                </div>
            </div>
        )
    }

}
export default InvoiceIssuanceBill;
